export default __webpack_public_path__ + "static/media/what-was-god-doing-before-creation-updated.f691c35e.jpg";